import React from "react";
import cvData from "../data/cvData.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faGithub,
  faInstagram,
  faLinkedin,
  faUnsplash,
} from "@fortawesome/free-brands-svg-icons";

const iconMap = {
  linkedin: faLinkedin,
  github: faGithub,
  facebook: faFacebook,
  unsplash: faUnsplash,
  instagram: faInstagram,
};

const Footer = () => {
  return (
    <footer className="relative z-10 mx-auto w-full max-w-6xl px-6 pb-10">
      <div className="glass-panel glass-sheen flex justify-center gap-6 p-4">
        {cvData.socialMedia.map((social, index) => {
          const iconKey = social.icon?.toLowerCase();
          const icon = iconMap[iconKey];

          if (!icon) {
            return null;
          }

          return (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="me noopener noreferrer"
              className="text-xl text-text-secondary transition-colors duration-200 hover:text-main-color"
              aria-label={social.name}
              title={social.name}
            >
              <FontAwesomeIcon icon={icon} />
            </a>
          );
        })}
      </div>
    </footer>
  );
};

export default Footer;
